/** Modified version of https://github.com/cytoscape/cytoscape.js-panzoom - MIT License
**/
 let jQuery = require('jquery');
let cytoscape = require('cytoscape');

export function AddPanZoom() {
    if (!cytoscape) {
        return;
    }
    let defaults = {
        zoomFactor: 0.05,
        zoomDelay: 45,
        minZoom: 0.1,
        maxZoom: 10,
        fitPadding: 50,
        panSpeed: 10,
        panDistance: 10,
        panDragAreaSize: 75,
        panMinPercentSpeed: 0.25,
        panInactiveArea: 8,
        panIndicatorMinOpacity: 0.5,
        zoomOnly: false,
        fitSelector: undefined,
        animateOnFit: function() {
            return false;
        },
        fitAnimationDuration: 1000,
        sliderHandleIcon: 'minus',
        zoomInIcon: 'plus',
        zoomOutIcon: 'minus',
        resetIcon: 'expand'
    };

    let panzoom = function(params, $) {
        let cyRef = this;
        let options = $.extend(true, {}, defaults, params);
        let fn = params;

        let functions = {
            destroy: function() {
                let $this = $(cyRef.container());
                let $pz = $this.find(".cy-panzoom");
                $pz.data('winbdgs').forEach(function(l) {
                    $(window).unbind( l.evt, l.fn );
                });
                $pz.data('cybdgs').forEach(function(l) {
                    cyRef.off( l.evt, l.fn );
                });
                $pz.remove();
            },

            init: function() {
                let browserIsMobile = 'ontouchstart' in window;
                return $(cyRef.container()).each(function() {
                    let $container = $(this);
                    $container.cytoscape = cytoscape;
                    let winbdgs = [];
                    let $win = $(window);
                    let windowBind = function(evt, fn) {
                        winbdgs.push({ evt: evt, fn: fn });
                        $win.bind( evt, fn );
                    };
                    let windowUnbind = function(evt, fn) {
                        for (let i = 0; i < winbdgs.length; i++) {
                            let l = winbdgs[i];
                            if (l.evt === evt && l.fn === fn) {
                                winbdgs.splice(i, 1);
                                break;
                            }
                        }
                        $win.unbind( evt, fn );
                    };

                    let cybdgs = [];

                    let cyOn = function(evt, fn) {
                        cybdgs.push({ evt: evt, fn: fn });
                        cyRef.on( evt, fn );
                    };

                    let cyOff = function(evt, fn) {
                        for (let i = 0; i < cybdgs.length; i++) {
                            let l = cybdgs[i];
                            if (l.evt === evt && l.fn === fn) {
                                cybdgs.splice( i, 1 );
                                break;
                            }
                        }
                        cyRef.off( evt, fn );
                    };

                    let $panzoom = $('<div class="cy-panzoom"></div>');
                    $container.prepend($panzoom);
                    $panzoom.css('position', 'absolute');
                    $panzoom.data('winbdgs', winbdgs);
                    $panzoom.data('cybdgs', cybdgs);
                    if (options.zoomOnly) {
                        $panzoom.addClass("cy-panzoom-zoom-only");
                    }

                    let $zoomIn = $('<div class="cy-panzoom-zoom-in cy-panzoom-zoom-button"><clr-icon class="icon-zoom is-inverse" shape="plus"></clr-icon></div>');
                    $panzoom.append($zoomIn);

                    let $zoomOut = $('<div class="cy-panzoom-zoom-out cy-panzoom-zoom-button"><clr-icon class="icon-zoom is-inverse" shape="minus"></clr-icon></div>');
                    $panzoom.append($zoomOut);

                    let $reset = $('<div class="cy-panzoom-reset cy-panzoom-zoom-button"><clr-icon class="icon-zoom is-highlight" shape="window-restore"></clr-icon></span></div>');
                    $panzoom.append($reset);

                    let $slider = $('<div class="cy-panzoom-slider"></div>');
                    $panzoom.append($slider);

                    $slider.append('<div class="cy-panzoom-slider-background"></div>');

                    let $sliderHandle = $('<div class="cy-panzoom-slider-handle"></span></div>');
                    $slider.append($sliderHandle);

                    let $noZoomTick = $('<div class="cy-panzoom-no-zoom-tick"></div>');
                    $slider.append($noZoomTick);

                    let $panner = $('<div class="cy-panzoom-panner"></div>');
                    $panzoom.append($panner);

                    let $pHandle = $('<div class="cy-panzoom-panner-handle"></div>');
                    $panner.append($pHandle);

                    let $pUp = $('<div class="cy-panzoom-pan-up cy-panzoom-pan-button"></div>');
                    let $pDown = $('<div class="cy-panzoom-pan-down cy-panzoom-pan-button"></div>');
                    let $pLeft = $('<div class="cy-panzoom-pan-left cy-panzoom-pan-button"></div>');
                    let $pRight = $('<div class="cy-panzoom-pan-right cy-panzoom-pan-button"></div>');
                    $panner.append( $pUp ).append( $pDown ).append( $pLeft ).append( $pRight );

                    let $pIndicator = $('<div class="cy-panzoom-pan-indicator"></div>');
                    $panner.append($pIndicator);

                    // functions for calculating panning
                    ////////////////////////////////////

                    function handle2pan(e) {
                        let v = {
                            x: e.originalEvent.pageX - $panner.offset().left - $panner.width()/2,
                            y: e.originalEvent.pageY - $panner.offset().top - $panner.height()/2
                        };

                        let r = options.panDragAreaSize;
                        let d = Math.sqrt( v.x*v.x + v.y*v.y );
                        let percent = Math.min( d/r, 1 );

                        if (d < options.panInactiveArea) {
                            return {
                                x: NaN,
                                y: NaN
                            };
                        }

                        v = {
                            x: v.x/d,
                            y: v.y/d
                        };

                        percent = Math.max(options.panMinPercentSpeed, percent);

                        let vnorm = {
                            x: -1 * v.x * (percent * options.panDistance),
                            y: -1 * v.y * (percent * options.panDistance)
                        };
                        return vnorm;
                    }

                    function donePanning() {
                        clearInterval(panInterval);
                        windowUnbind("mousemove", handler);
                        $pIndicator.hide();
                    }

                    function positionIndicator(pan) {
                        let v = pan;
                        let d = Math.sqrt(v.x * v.x + v.y * v.y);
                        let vnorm = {
                            x: -1 * v.x/d,
                            y: -1 * v.y/d
                        };
                        let w = $panner.width();
                        let h = $panner.height();
                        let percent = d/options.panDistance;
                        let opacity = Math.max(options.panIndicatorMinOpacity, percent);
                        let color = 255 - Math.round(opacity * 255);

                        $pIndicator.show().css({
                            left: w/2 * vnorm.x + w/2,
                            top: h/2 * vnorm.y + h/2,
                            background: "rgb(" + color + ", " + color + ", " + color + ")"
                        });
                    }

                    function calculateZoomCenterPoint() {
                        let pan = cyRef.pan();
                        let zoom = cyRef.zoom();
                        zx = $container.width()/2;
                        zy = $container.height()/2;
                    }

                    let zooming = false;
                    function startZooming() {
                        zooming = true;
                        calculateZoomCenterPoint();
                    }

                    function endZooming() {
                        zooming = false;
                    }

                    let zx, zy;
                    function zoomTo(level) {
                        if(!zooming) { // for non-continuous zooming (e.g. click slider at pt)
                            calculateZoomCenterPoint();
                        }
                        cyRef.zoom({
                            level: level,
                            renderedPosition: { x: zx, y: zy }
                        });
                    }

                    let panInterval;

                    let handler = function(e) {
                        e.stopPropagation(); // don't trigger dragging of panzoom
                        e.preventDefault(); // don't cause text selection
                        clearInterval(panInterval);
                        let pan = handle2pan(e);
                        if (isNaN(pan.x) || isNaN(pan.y)) {
                            $pIndicator.hide();
                            return;
                        }

                        positionIndicator(pan);
                        panInterval = setInterval(function() {
                            cyRef.panBy(pan);
                        }, options.panSpeed);
                    };

                    $pHandle.bind("mousedown", function(e) {
                        // handle click of icon
                        handler(e);
                        // update on mousemove
                        windowBind("mousemove", handler);
                    });

                    $pHandle.bind("mouseup", function() {
                        donePanning();
                    });

                    windowBind("mouseup blur", function() {
                        donePanning();
                    });


                    $slider.bind('mousedown', function() {
                        return false; // so we don't pan close to the slider handle
                    });

                    let sliderVal;
                    let sliding = false;
                    let sliderPadding = 2;

                    function setSliderFromMouse(evt, handleOffset) {
                        if ( handleOffset === null || handleOffset === undefined) {
                            handleOffset = 0;
                        }
                        let padding = sliderPadding;
                        let min = 0 + padding;
                        let max = $slider.height() - $sliderHandle.height() - 2 * padding;
                        let top = evt.pageY - $slider.offset().top - handleOffset;
                        if (top < min ) {
                            top = min;
                        }
                        if (top > max ) {
                            top = max;
                        }
                        let percent = 1 - (top - min) / ( max - min );
                        // move the handle
                        $sliderHandle.css('top', top);
                        let zmin = options.minZoom;
                        let zmax = options.maxZoom;
                        // assume (zoom = zmax ^ p) where p ranges on (x, 1) with x negative
                        let x = Math.log(zmin) / Math.log(zmax);
                        let p = (1 - x) * percent + x;
                        // change the zoom level
                        let z = Math.pow(zmax, p);
                        // bound the zoom value in case of floating pt rounding error
                        if(z < zmin) {
                            z = zmin;
                        } else if (z > zmax) {
                            z = zmax;
                        }
                        zoomTo(z);
                    }

                    let sliderMdownHandler, sliderMmoveHandler;
                    $sliderHandle.bind('mousedown', sliderMdownHandler = function(mdEvt) {
                        let handleOffset = mdEvt.target === $sliderHandle[0] ? mdEvt.offsetY : 0;
                        sliding = true;
                        startZooming();
                        $sliderHandle.addClass("active");
                        let lastMove = 0;
                        windowBind('mousemove', sliderMmoveHandler = function(mmEvt) {
                            let now = +new Date;
                            // throttle the zooms every 10 ms so we don't call zoom too often and cause lag
                            if( now > lastMove + 10 ){
                                lastMove = now;
                            } else {
                                return false;
                            }
                            setSliderFromMouse(mmEvt, handleOffset);
                            return false;
                        });

                        // unbind when
                        windowBind('mouseup', function() {
                            windowUnbind('mousemove', sliderMmoveHandler);
                            sliding = false;
                            $sliderHandle.removeClass("active");
                            endZooming();
                        });
                        return false;
                    });

                    $slider.bind('mousedown', function(e) {
                        if (e.target !== $sliderHandle[0]) {
                            sliderMdownHandler(e);
                            setSliderFromMouse(e, null);
                        }
                    });

                    function positionSliderFromZoom() {
                        let z = cyRef.zoom();
                        let zmin = options.minZoom;
                        let zmax = options.maxZoom;
                        // assume (zoom = zmax ^ p) where p ranges on (x, 1) with x negative
                        let x = Math.log(zmin) / Math.log(zmax);
                        let p = Math.log(z) / Math.log(zmax);
                        let percent = 1 - (p - x) / (1 - x); // the 1- bit at the front b/c up is in the -ve y direction
                        let min = sliderPadding;
                        let max = $slider.height() - $sliderHandle.height() - 2 * sliderPadding;
                        let top = percent * ( max - min );
                        if (top < min) {
                            top = min;
                        }
                        if (top > max) {
                            top = max;
                        }
                        $sliderHandle.css('top', top);
                    }
                    positionSliderFromZoom();

                    cyOn('zoom', function() {
                        if (!sliding) {
                            positionSliderFromZoom();
                        }
                    });

                    (function() {
                        let z = 1;
                        let zmin = options.minZoom;
                        let zmax = options.maxZoom;
                        let x = Math.log(zmin) / Math.log(zmax);
                        let p = Math.log(z) / Math.log(zmax);
                        let percent = 1 - (p - x) / (1 - x);
                        if (percent > 1 || percent < 0) {
                            $noZoomTick.hide();
                            return;
                        }
                        let min = sliderPadding;
                        let max = $slider.height() - $sliderHandle.height() - 2*sliderPadding;
                        let top = percent * ( max - min );
                        if (top < min) {
                            top = min;
                        }
                        if (top > max) {
                            top = max;
                        }
                        $noZoomTick.css('top', top);
                    })();

                    function bindButton($button, factor){
                        let zoomInterval;
                        $button.bind("mousedown", function(e){
                            e.preventDefault();
                            e.stopPropagation();
                            if (e.button != 0) {
                                return;
                            }
                            let doZoom = function(){
                                let zoom = cyRef.zoom();
                                let lvl = cyRef.zoom() * factor;
                                if (lvl < options.minZoom) {
                                    lvl = options.minZoom;
                                }

                                if (lvl > options.maxZoom ) {
                                    lvl = options.maxZoom;
                                }
                                if ((lvl == options.maxZoom && zoom == options.maxZoom) ||
                                    (lvl == options.minZoom && zoom == options.minZoom)) {
                                    return;
                                }
                                zoomTo(lvl);
                            };
                            startZooming();
                            doZoom();
                            zoomInterval = setInterval(doZoom, options.zoomDelay);
                            return false;
                        });

                        windowBind("mouseup blur", function() {
                            clearInterval(zoomInterval);
                            endZooming();
                        });
                    }
                    bindButton($zoomIn, (1 + options.zoomFactor));
                    bindButton($zoomOut, (1 - options.zoomFactor));

                    $reset.bind("mousedown", function(e) {
                        if (e.button != 0) {
                            return;
                        }
                        let elesToFit = options.fitSelector?cyRef.elements(options.fitSelector):cyRef.elements();

                        if (elesToFit.size() === 0) {
                            cyRef.reset();
                        } else {
                            let animateOnFit = typeof options.animateOnFit === 'function' ? options.animateOnFit.call() : options.animateOnFit;
                            if (animateOnFit) {
                                cyRef.animate({
                                    fit: {
                                        eles: elesToFit,
                                        padding: options.fitPadding
                                    }
                                }, {
                                    duration: options.fitAnimationDuration
                                });
                            }
                            else {
                                cyRef.fit(elesToFit, options.fitPadding);
                            }

                        }
                        return false;
                    });

                });
            }
        };

        if (functions[fn]) {
            return functions[fn].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof fn == 'object' || !fn) {
            return functions.init.apply( this, arguments );
        } else {
            $.error("No such function `"+ fn +"` for jquery.cytoscapePanzoom");
        }
        return $(this);
    };

    let register = function(cytoscape, $) {
        if (!cytoscape) {
            return;
        }
        cytoscape('core', 'PanZoom', function(options) {
            panzoom.apply(this , [options, $]);
            return this;
        });

    };

    if (typeof cytoscape !== 'undefined') {
        register(cytoscape, jQuery);
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-graph/vca-graph-panzoom.cytoscape.ts